import React from "react";
import { FaLeaf, FaHandSparkles } from 'react-icons/fa';
import { MdOutlineWaterDrop, MdOutlineLandscape } from 'react-icons/md';
import { FaCheckCircle } from "react-icons/fa";
import ContactForm from "../components/ContactForm"; 
import { Helmet } from 'react-helmet';  // Importera Helmet

const Tradgardsskosel = () => {
  return (
    <>
    <Helmet>
            <title>Trädgårdsskötsel – Provalt Service AB</title>
            <meta name="description" content="Håll din trädgård välvårdad året runt med våra professionella tjänster för gräsklippning, ogräsrensning och allmän skötsel." />
            <link rel="canonical" href="https://provalt.se/tradgardsskotsel" />
          </Helmet>
      {/* Fullbreddig bakgrundssektion */}
      <section
        className="relative h-[50vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: "url('/images/gardening/provalt-trädgårdsskötsel-2.webp')", // se till att bilden finns i public/images/cleaning/
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />
        <div className="relative z-10 text-center p-6 bg-black bg-opacity-30">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Trädgårdsskötsel</h1>
          <p className="text-xl md:text-2xl font-semibold">
            Låt din trädgård blomstra med professionell skötsel
          </p>
        </div>
      </section>

      {/* Innehållssektion */}
      <section className="py-16 px-6 md:px-12 bg-white text-gray-800">
        <div className="max-w-6xl mx-auto">
          <p className="text-lg mb-8">
            Vi på Provalt Service AB erbjuder professionell trädgårdsskötsel som säkerställer att din trädgård alltid ser välvårdad och inbjudande ut. Vi tar hand om alla aspekter av trädgårdsskötseln, från gräsklippning till häckklippning och plantering.
          </p>

          <div className="grid md:grid-cols-2 gap-10">
            {/* Gräsklippning */}
            <div className="flex items-start">
              <FaLeaf className="text-green-600 w-8 h-8 mr-4 mt-1" />
              <div>
                <h3 className="text-xl font-semibold">Gräsklippning</h3>
                <p>
                  Regelbunden gräsklippning håller gräsmattan frisk och välvårdad. Vi klipper enligt ett schema som passar dig.
                </p>
              </div>
            </div>

            {/* Vattning */}
            <div className="flex items-start">
              <MdOutlineWaterDrop className="text-blue-500 w-8 h-8 mr-4 mt-1" />
              <div>
                <h3 className="text-xl font-semibold">Vattning</h3>
                <p>
                  Effektiv bevattning säkerställer växternas tillväxt. Vi erbjuder även installation av automatiska bevattningssystem.
                </p>
              </div>
            </div>

            {/* Häckklippning */}
            <div className="flex items-start">
              <MdOutlineLandscape className="text-amber-800 w-8 h-8 mr-4 mt-1" />
              <div>
                <h3 className="text-xl font-semibold">Häckklippning</h3>
                <p>
                  Snyggt formade häckar förbättrar helhetsintrycket. Vi klipper och formar efter dina önskemål.
                </p>
              </div>
            </div>

            {/* Trädgårdsrengöring */}
            <div className="flex items-start">
              <FaHandSparkles className="text-yellow-600 w-8 h-8 mr-4 mt-1" />
              <div>
                <h3 className="text-xl font-semibold">Trädgårdsrengöring</h3>
                <p>
                  Vi tar hand om löv, kvistar och skräp så att din trädgård alltid ser fräsch och inbjudande ut.
                </p>
              </div>
            </div>
          </div>

          {/* Varför välja oss */}
          <div className="mt-16">
            <h3 className="text-2xl font-semibold text-green-700 mb-6">Varför välja oss för Trädgårdsskötsel?</h3>
            <ul className="list-disc pl-6 space-y-3 text-lg">
              <li>Professionell utrustning och pålitlig service.</li>
              <li>Anpassade lösningar efter dina behov.</li>
              <li>Miljövänliga metoder och produkter.</li>
              <li>Erfarna och kunniga trädgårdsmästare.</li>
              <li>Underhållsplaner för året runt-skötsel.</li>
            </ul>
          </div>

        </div>
      </section>
      <section
      className="relative py-20 bg-green-200 px-6 md:px-12 text-gray-900">
      {/* Vit overlay med transparens */}
      <div className="absolute inset-0 bg-white/90 backdrop-blur-sm"></div>

      <div className="relative max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
        {/* Textinnehåll */}
        <div className="space-y-8">
          <h2 className="text-3xl font-extrabold leading-tight">
            Professionell trädgårdsskötsel året runt
          </h2>
          <ul className="space-y-6 text-lg">
            <li className="flex items-start">
              <FaCheckCircle className="text-green-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Allsidig trädgårdsvård:</strong> Ogräsrensning, gräsklippning och häckklippning med noggrannhet.
              </p>
            </li>
            <li className="flex items-start">
              <FaCheckCircle className="text-green-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Miljövänliga metoder:</strong> Vi använder hållbara och skonsamma tekniker för din trädgård.
              </p>
            </li>
            <li className="flex items-start">
              <FaCheckCircle className="text-green-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Flexibla tjänster:</strong> Anpassade lösningar efter dina behov, året runt.
              </p>
            </li>
          </ul>
        </div>

        {/* Formulär */}
        <div className="bg-white p-10 rounded-3xl shadow-xl max-w-md w-full mx-auto">
          <ContactForm service="Trädgårdsskötsel" />
        </div>
      </div>
    </section>
    </>
  );
};

export default Tradgardsskosel;
